import { SharePlanType, SharePlanVestingType } from '../../../../types/pool-plans.types';
import { TemplateCategory, TemplateSubCategory } from '../enums/template.const';

export type BaseTemplateContext = {
  category: TemplateCategory;
  subCategory: TemplateSubCategory;
};

export type GrantTemplateContext = {
  category: TemplateCategory.GRANT;
  hasAccelerationDate?: boolean;
  hasCliff?: boolean;
  hasVesting?: boolean;
  milestonesCount?: number;
  periodsCount?: number;
  planType?: SharePlanType;
  subCategory: TemplateSubCategory;
  vestingType?: SharePlanVestingType;
};

export type TemplateFieldContext = BaseTemplateContext | GrantTemplateContext;

export const TEMPLATE_CATEGORIES_WITH_CONTEXT = [TemplateCategory.GRANT];
export type TemplateCategoryWithContext = (typeof TEMPLATE_CATEGORIES_WITH_CONTEXT)[number];

export const isGrantContext = (ctx: TemplateFieldContext): ctx is GrantTemplateContext => {
  return ctx.category === TemplateCategory.GRANT;
};
